<template>
	<div class="mb-4">
		<h2 class="generalTitle">Nueva promoción</h2>
		<router-view/>
	</div>
</template>

<script>
export default {
  name: 'NewContract',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>